import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import * as React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { I18nextProvider } from 'react-i18next'
import { RecoilRoot } from 'recoil'

import i18n from '@/lib/i18n'

type AppProviderProps = {
  queryClient: QueryClient
  children: React.ReactNode
}

export const AppProvider = ({ queryClient, children }: AppProviderProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <I18nextProvider i18n={i18n}>
          {process.env.NEXT_IS_TEST !== 'true' && <ReactQueryDevtools />}
          <Toaster />
          {children}
        </I18nextProvider>
      </RecoilRoot>
    </QueryClientProvider>
  ) : null
}
